import { Box, Paragraph } from 'grommet'
import styled, { css } from 'styled-components'

export const Wrapper = styled(Box)`
  ${({ theme }) => css`
    background-color: ${theme.newColors.lightGray};
    margin-top: ${theme.newSpaces.lg}px;
    padding: ${theme.newSpaces.xs}px;

    ${theme.below.mobileXL`
      padding: ${theme.newSpaces.xs2}px;
      margin-top: ${theme.newSpaces.xs}px;
    `}
  `}
`

export const Title = styled(Paragraph)`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'title2')}

    color: ${theme.newColors.darkGray};
    margin-bottom: ${theme.newSpaces.xs}px;

    ${theme.below.mobileXL`
      font-size: 13px;
      line-height: ${theme.typography.mobile.button.medium.lineHeight}px;
      margin-bottom: ${theme.newSpaces.xs2}px;
    `}
  `}
`

export const List = styled.ul`
  ${({ theme }) => css`
    list-style: none;
    margin-bottom: ${theme.newSpaces.xs2}px;

    ${theme.below.mobileXL`
      margin-bottom: 0;
    `}
  `}
`

export const ListItem = styled.li`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'body', 'body3')}

    background-image: url('/images/list-hexagon.svg');
    background-position: left 18%;
    background-repeat: no-repeat;
    background-size: 14px;
    color: ${theme.newColors.darkGray};
    margin: ${theme.newSpaces.xs}px 0;
    padding-left: ${theme.newSpaces.sm}px;

    &:last-child {
      margin-bottom: 0;
    }

    &:first-child {
      background-position: left 10%;
      margin-top: 0;
    }

    ${theme.above.laptopL`
      white-space: normal;
    `}

    ${theme.below.laptopL`
      white-space: pre-wrap;
    `}

    ${theme.below.mobileXL`
      font-size: 8px;
      line-height: 13px;
      margin: 7px 0;
      padding-left: 12px;
      background-size: 8px;
      background-position: left 17%;

      &:first-child {
        background-position: left 12%;
      }
    `}

    ${theme.below.mobileM`
      white-space: normal;
    `}
  `}
`

export const ListSpan = styled.span`
  ${({ theme }) => css`
    font-weight: ${theme.typography.desktop.title.title4.fontWeight};
  `}
`
